import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api'

function initialState() {
    return {
            list: [],
            
        };
}

const state = initialState();

// actions 

const actions = {
    async create(context,payload) {
        var response = await API.filmRight.create(payload)
        return response;
    },

    async list(context,payload) {
        var response = await API.filmRight.list(payload)
        // set agreements in list
        context.commit('set_list', {
            filmRights: response.filmrights
        })
        return response;
    },

    async update(context,payload) {
        var response = await API.filmRight.update(payload)
        return response;
    },

    async delete(context,payload) {
        var response = await API.filmRight.delete(payload)
        return response;
    },

}

// getters
const getters = {
    getField,
   

};

// mutations
const mutations = {
    updateField,
    set_list(state,payload) {
        state.list = payload.filmRights
    },

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
          state[key] = s[key];
        });
    },
    
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}